import { useMutation } from '@tanstack/react-query';

import { addMediaApi } from './api';

const useUploadIcon = () => {
  const { mutateAsync: uploadIconMutate } = useMutation(
    ['uploadIcon'],
    async ({ file, returnFormat }) => {
      if (typeof file === 'string') {
        if (returnFormat) {
          return returnFormat(file);
        }

        return file;
      }

      const formDataIcon = new FormData();
      formDataIcon.append('media', file);

      const { data } = await addMediaApi(formDataIcon);

      if (returnFormat) {
        return returnFormat(data);
      }

      return data;
    },
    {
      onError: (error) => error,
    }
  );

  return { uploadIconMutate };
};

export default useUploadIcon;
